import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import './assets/styles/main.scss';
import AppRouter from './AppRouter';
// import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');

const root = ReactDOMClient.createRoot(container as HTMLElement);

root.render(<AppRouter />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
